import DefaultLayout from "layouts/Default";
import {wrapper} from "lib/store";
import {getLocation} from "lib/features/locationSlice";
import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {regular, solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import ImageWithFallback from "components/ImageWithFallback";
import {getServiceById} from "lib/services/product";
import Link from "next/link";
import Rating from "components/Rating";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {Button, Chip} from "@mui/material";
import TextField from "@mui/material/TextField";
import React, {useEffect, useState} from "react";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {getPaginatedBrandsThunk} from "lib/features/brandSlice";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    query,locale,
  } = context
  console.log('query: ', query)
  await store.dispatch(getLocation({slug: query.locationSlug}))
  const product = await getServiceById({id: query.id})

  return {
    props: {
      product,
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})

const Title = (props) => {
  const {
    children
  } = props
  return (
    <div className="font-bold">
      {children}
    </div>
  )
}

export default function Id(props) {
  const {
    product
  } = props
  const { t } = useTranslation()
  const location = useSelector(state => state.location.location, shallowEqual)
  let brands = useSelector(state => state.brand.brands, shallowEqual)
  const [quantity, setQuantity] = useState(1);
  const [serviceBrand, setServiceBrand] = useState('')
  const dispatch = useDispatch()
  useEffect(() => {
    console.log('product: ', product)
    let brand = brands.find(item => item.id === product.brand_id)
    if (brand !== undefined) {
      setServiceBrand(brand.name)
    }
  }, [])

  useEffect(() => {
    if (brands[0].name === 'Test') {
      const sort = {}
      const page = 1
      const filter = {}
      dispatch(getPaginatedBrandsThunk({page, filter, sort}))
    } else {
      let relativeBrand = brands.find(item => item.id === product.brand_id)
      if (relativeBrand !== undefined) {
        setServiceBrand(relativeBrand)
      }
    }
  }, [brands])

  return (
    <Wrapper>
      <Container className={'flex gap-8'}>
        <div className="w-1/4 shrink-0">
          <div className={'relative pb-[100%]'}>
            <ImageWithFallback
              src={product.images[0]}
              alt={product.name}
              className={' object-contain'}
            />
          </div>
        </div>
        <div className="flex-grow flex flex-col">
          <div className="text-gray-500 text-sm">
            {
              serviceBrand.name !== '' ?
                  `${t(`home:${product.category}`)} | By ` :
                  t(`home:${product.category}`)
            }
            {serviceBrand.name !== '' ?
              <Link href={`/brands/${serviceBrand.slug}/${serviceBrand.id}`}>
                <a className={'text-primary'}>
                  {serviceBrand.name}
                </a>
              </Link> : null
              }
          </div>
          {/*<div className="text-gray-500 text-sm">*/}
          {/*  {product.category.name} | By {' '}*/}
          {/*  {<Link href={`/brands/${serviceBrand}`}>*/}
          {/*    <a className={'text-primary'}>*/}
          {/*      {serviceBrand}*/}
          {/*    </a>*/}
          {/*  </Link>}*/}
          {/*</div>*/}
          <h2 className="font-bold text-2xl mt-1 mb-2">
            {product.name}
          </h2>
          {
            product.rating ?
                <div className="mb-2 flex flex-nowrap items-center mb-4 text-gray-500">
                  <div className="text-xs mr-2">
                    {product.rating.toFixed(1)}
                  </div>
                  <Rating
                      value={product.rating || 5}
                      precision={0.5}
                      readOnly
                      className={'mr-2'}
                  />
                  <div className="text-xs">
                    ({product.reviews_count})
                  </div>
                </div> : null
          }
          <div className="self-start mb-3 rounded border overflow-hidden flex flex-nowrap items-center">
            <div className="w-10 h-10 relative">
              <ImageWithFallback
                src={location.avatar_url}
                alt={location.name}
                className={'object-cover'}
              />
            </div>
            <div className="text-sm pl-2 pr-4">{t('home:product_detail_page_pickupat')}
              <span className={"text-gray-500"}>{location.name}</span>
            </div>
          </div>
          <div className="rounded border px-4 py-2 mb-3 self-start inline-block">
            <div className="flex mb-2">
              {
                product.price > 0 ?
                    <div className="font-bold text-xl">${product.price_compare > 0 ? product.price_compare : product.price}</div> : null
              }
              {
                <div className="ml-2 text-gray-500 font-semibold line-through leading-normal">
                  ${product.price_compare > 0  ? product.price : ''}
                </div>
              }
            </div>
            <div className="text-sm text-gray-500">{product.weight}</div>
          </div>
          <Title>{t('home:product_detail_quantity')}</Title>
          <TextField
            className={'my-2 self-start'}
            size={'small'}
            value={quantity}
            inputProps={{
              className: "text-center",
              inputMode: "numeric",
              pattern: '[0-9]*'
            }}
            InputProps={{
              className: "p-0 w-[150px]",
              startAdornment: <Button type={'contain'} className={"self-stretch !min-w-[40px]"} onClick={() => setQuantity(quantity - 1)}><FontAwesomeIcon icon={solid('minus')}/></Button>,
              endAdornment: <Button type={'contain'} className={"self-stretch !min-w-[40px]"} onClick={() => setQuantity(quantity + 1)}><FontAwesomeIcon icon={solid('plus')}/></Button>
            }}
            />
          <Button
              className={'rounded-full self-start px-8 whitespace-nowrap'}
            variant={'outlined'} size={'small'}
          >
            {t('home:product_detail_addtocart')}
            <FontAwesomeIcon icon={solid('bag-shopping')} className={'ml-2'}/>
          </Button>
          <div className="mb-6"></div>

          <Title>{t('home:service_detail_service_description')}</Title>
          <div className="mb-4"></div>
          <p className={"whitespace-pre-line"}>{product.description}</p>
          <div className="mb-6"></div>

          {
            product.strain ?
                <>
                  <Title>{`${t('home:product_detail_aboutthisstrain')}: ${t('home:tba')}`}</Title>
                  <div className="mb-4"></div>
                  <p className={"whitespace-pre-line"}>{t('home:tba')}</p>
                  <div className="mb-6"></div>

                  <Title>{t('home:product_detail_top_reported_strain_effects')}</Title>
                  <div className="mb-2"></div>
                  <div>
                    {
                      <p className={"whitespace-pre-line"}>{t('home:tba')}</p>
                      // product.strain.effect ?
                      //     product.strain.effects.map(effect => (
                      //         <Chip
                      //             key={effect.slug}
                      //             className={"mr-2 mb-1 bg-primary text-white px-4"}
                      //             size={'small'}
                      //             label={effect.name}
                      //         />
                      //     )) : null
                    }
                  </div>

                  <div className="mb-6"></div>

                  <Title>{t('home:product_detail_top_reported_strain_flavors')}</Title>
                  <div className="mb-2"></div>
                  <div>
                    {
                      <p className={"whitespace-pre-line"}>{t('home:tba')}</p>
                      // product.strain.flavours ?
                      //     product.strain.flavours.map(flavour => (
                      //         <Chip
                      //             key={flavour.slug}
                      //             className={"mr-2 mb-1 bg-yellow-500 text-white px-4"}
                      //             size={'small'}
                      //             label={flavour.name}
                      //         />
                      //     )) : null
                    }
                  </div>

                  <div className="mb-6"></div>

                  <div className="flex">
                    <Button
                        variant={"outlined"}
                        className={"border-gray-400 text-gray-500 mr-3 hover:text-pink-500 hover:border-pink-400 hover:bg-pink-50"}
                    >
                      <FontAwesomeIcon icon={regular('heart')} className={"mr-2 text-pink-500"}/>
                      {t('home:product_detail_favorite')}
                    </Button>
                    <Button
                        variant={"outlined"}
                        className={"border-gray-400 text-gray-500 hover:text-primary-dark"}
                    >
                      <FontAwesomeIcon icon={solid('share')} className={"mr-2"}/>
                      {t('home:product_detail_share')}
                    </Button>
                  </div>
                </> : null
          }

        </div>
      </Container>
    </Wrapper>
  )
}

Id.getLayout = function getLayout(page) {
  return (
    <DefaultLayout>
        {page}
    </DefaultLayout>
  )
}
